import React, { useState } from 'react';
import styles from './EditProfileDetailsByAdmin.module.scss';
import ReactModal from 'react-modal';
import PhoneInput from 'react-phone-number-input';
import { useAtom } from 'jotai';
import 'react-phone-number-input/style.css';
import { ReactComponent as XIcon } from 'assets/img/close.svg';
import { editProfileDetailsPopupAtom } from 'showMessageMenuAtom';
import { ReactComponent as Twitter } from 'assets/img/x-twitter.svg'
import { ReactComponent as Facebook } from 'assets/img/facebook.svg'
import { ReactComponent as IG } from 'assets/img/instagram.svg'
import { ReactComponent as LinkedIn } from 'assets/img/linkedin.svg'
import { ReactComponent as Website } from 'assets/img/globe.svg'
import { UserService } from 'api/services/users/UserService';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { toast } from 'react-toastify';
import SelectionDropDown from 'components/SelectionDropdown';
import SingleQuestion from 'containers/CommunityOnboardingSteps/CommunityMembershipQuestions/QuestionsTypesFields/SingleQuestion/SingleQuestion';
import { QuestionTypes } from 'containers/Onboarding/MembershipQuestions/QuestionMaker/domain';
import { GroupService } from 'api/services/groups';

interface NotificationsFormData {
    broadcast_email_notification: boolean;
    post_email_notification: boolean;
    unread_messages_email_notification: boolean;
    course_email_notification: boolean;
    digest_email_frequency: number;
    event_digest_email_frequency: number;
    event_rsvp_email_notification: boolean;
    library_digest_email_frequency: number;
    mention_email_notification: boolean;
    automated_email_notification: any;
}


const EditProfileDetailsByAdmin = ({ user, group, fetchUserMembershipDetails }: { user: any, group: any, fetchUserMembershipDetails: any }) => {

    const userDetails = user.user
    const digestEmailOptions = ['Daily', 'Weekly', 'Every 14-days', 'Monthly', 'Never'];
    const upComimgEventEmailOptions = digestEmailOptions;
    const newContentEmailOptions = digestEmailOptions;
    const initialQuestionsRef: any = React.useRef<Map<number, any>>(new Map());

    const [editProfileDetailsPopup, seteditProfileDetailsPopup] = useAtom(editProfileDetailsPopupAtom)
    const [userData, setUserData] = useState<any>(userDetails)
    const [editData, setEditData] = useState<any>({})
    const [countries, setCountries] = useState<any>(null);
    const [timezones, setTimezones] = useState<any>(null);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [workflowEmail, setWorkflowEmail] = useState<any>(false);
    const [automatedEmailSettings, setAutomatedEmailSettings] = useState<any>(userDetails && userDetails.automated_email_notification);

    const [notificationsFormData, setNotificationsFormData] = useState<NotificationsFormData>({
        broadcast_email_notification: user.broadcast_email_notification,
        post_email_notification: user.post_email_notification,
        unread_messages_email_notification: user.unread_messages_email_notification,
        course_email_notification: user.course_email_notification,
        digest_email_frequency: user.digest_email_frequency,
        event_digest_email_frequency: user.event_digest_email_frequency,
        event_rsvp_email_notification: user.event_rsvp_email_notification,
        library_digest_email_frequency: user.library_digest_email_frequency,
        mention_email_notification: user.mention_email_notification,
        automated_email_notification: workflowEmail
    });

    const [questionResponse, setQuestionResponse] = React.useState<any>(null);
    const [membershipQuestions, setMembershipQuestions] = React.useState<any>(null);
    const [updatedAnswers, setUpdatedAnswers] = useState<any>([]);

    const onChange = (e: any) => {
        const value = e.target.value;

        if (!value.startsWith(' ')) {
            if (value === '') {
                // const newUserData = { ...userData };
                // const newEditData = { ...editData };
                // delete newUserData[e.target.name];
                // delete newEditData[e.target.name];
                // setUserData(newUserData);
                // setEditData(newEditData);
                setUserData({ ...userData, [e.target.name]: null });
                setEditData({ ...editData, [e.target.name]: null });
            } else {
                setUserData({ ...userData, [e.target.name]: e.target.value });
                setEditData({ ...editData, [e.target.name]: e.target.value })
            }
        }
    };


    const getCountries = () => {
        UserService.getInstance()
            .getCountries()
            .then((countriesResponse: any) => {
                setCountries(countriesResponse.data);
            }).catch((error: any) => console.error(error))
    };

    const getTimezones = () => {
        UserService.getInstance()
            .getTimezones()
            .then((timezonesResponse: any) => {
                setTimezones(timezonesResponse.data);
            }).catch((error: any) => console.error(error))
    };

    const isValid = () => {
        const regexMap = {
            instagram: /^https:\/\/.*instagram/i,
            linkedin: /^https:\/\/.*linkedin/i,
            facebook: /^https:\/\/.*facebook/i,
            twitter: /^https:\/\/.*twitter/i,
            x: /^https:\/\/.*x\.com/i,
            website: /^https?:\/\/.*/i
        };


        if (Object.keys(editData).length > 0) {
            if ((editData.full_name && editData.full_name.length < 2)) {
                toast("Please enter a valid Full Name", {
                    type: 'error',
                    autoClose: 3000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
                return;
            }

            if (editData.instagram) {
                if (!regexMap['instagram'].test(editData.instagram)) {
                    toast(`Please enter a valid Instagram link`, {
                        type: 'error',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });
                    return false
                }
            }
            if (editData.linkedin) {
                if (!regexMap['linkedin'].test(editData.linkedin)) {
                    toast(`Please enter a valid LinkedIn link`, {
                        type: 'error',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });
                    return false
                }
            }
            if (editData.facebook) {
                if (!regexMap['facebook'].test(editData.facebook)) {
                    toast(`Please enter a valid Facebook link`, {
                        type: 'error',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });
                    return false
                }
            }
            if (editData.twitter) {
                if (!regexMap['twitter'].test(editData.twitter) && !regexMap['x'].test(editData.twitter)) {
                    toast(`Please enter a valid X account (Formerly Twitter) link`, {
                        type: 'error',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });
                    return false;
                }
            }

            if (editData.website) {
                if (!regexMap['website'].test(editData.website)) {
                    toast(`Please enter a valid website URL`, {
                        type: 'error',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });
                    return false;
                }
            }

            return true
        }
        if (updatedAnswers && updatedAnswers.length > 0) {
            return true
        }
    }

    const handleForm = () => {
        if (editProfileDetailsPopup.editType === 'profile') {
            if (isValid()) {
                setIsSaving(true);
                const promises = [];

                if (Object.keys(editData).length > 0) {
                    promises.push(
                        UserService.getInstance()
                            .editProfileDetailsByAdmin(group.id, user.id,
                                {
                                    "user": editData
                                }
                            )
                    )
                }
                if (updatedAnswers.length > 0) {
                    // const mergedResponse = [
                    //     ...questionResponse.filter((item: any) => !updatedAnswers.some((updated: any) => updated.id === item.id)),
                    //     ...updatedAnswers
                    // ];
                    const mergedResponse = questionResponse.map((item: any) =>
                        updatedAnswers.find((updated: any) => updated.id === item.id) || item
                    );

                    // Add new items from updatedAnswers that don’t exist in questionResponse
                    const newItems = updatedAnswers.filter((updated: any) =>
                        !questionResponse.some((item: any) => item.id === updated.id)
                    );

                    const finalMergedResponse = [...mergedResponse, ...newItems];

                    promises.push(
                        UserService.getInstance()
                            .editProfileDetailsByAdmin(group.id, user.id,
                                {
                                    "membership": {
                                        "screening_response": finalMergedResponse
                                    }
                                }
                            )
                    )
                }
                Promise.all(promises)
                    .then(() => {
                        toast("Profile details updated successfully", {
                            type: 'success',
                            autoClose: 3000,
                            position: "top-center",
                            hideProgressBar: true,
                            theme: "light"
                        });
                        setIsSaving(false);
                    })
                    .catch((error: any) => {
                        console.error(error)
                        new Error(error)
                        setIsSaving(false);
                    }).finally(() => {
                        setEditData({});
                        setUpdatedAnswers([]);
                        initialQuestionsRef.current.clear();
                        fetchUserMembershipDetails()
                        setIsSaving(false);
                        seteditProfileDetailsPopup({ isOpen: false, editType: '' })
                    })
            }
        } else {
            setIsSaving(true);
            const promises = [];
            const { automated_email_notification, ...filteredData } = editData;

            if (editData.automated_email_notification && Object.keys(automated_email_notification).length > 0) {
                // First request for automated_email_notification
                promises.push(
                    UserService.getInstance()
                        .editProfileDetailsByAdmin(group.id, user.id,
                            {
                                "user": { automated_email_notification }
                            }
                        )
                )
            }
            if (Object.keys(filteredData).length > 0) {
                promises.push(
                    UserService.getInstance()
                        .editProfileDetailsByAdmin(group.id, user.id,
                            {
                                "membership": filteredData
                            }
                        )
                )
            }

            // Execute both requests sequentially and handle responses
            Promise.all(promises)
                .then(() => {
                    toast("Notification preferences updated successfully", {
                        type: 'success',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });
                })
                .catch((error) => {
                    console.error(error);
                    new Error(error);
                })
                .finally(() => {
                    setEditData({});
                    fetchUserMembershipDetails();
                    setIsSaving(false);
                    seteditProfileDetailsPopup({ isOpen: false, editType: '' })
                });
        }
    }

    const handleDiscard = () => {
        setEditData({})
        if (editProfileDetailsPopup.editType === 'profile') {
            setUserData(userDetails);
            setUpdatedAnswers([]);
            initialQuestionsRef.current.clear(); // Clear stored initial values
            assignQuestionResponse()
        } else {
            setNotificationsFormData({
                broadcast_email_notification: user.broadcast_email_notification,
                post_email_notification: user.post_email_notification,
                unread_messages_email_notification: user.unread_messages_email_notification,
                course_email_notification: user.course_email_notification,
                digest_email_frequency: user.digest_email_frequency,
                event_digest_email_frequency: user.event_digest_email_frequency,
                event_rsvp_email_notification: user.event_rsvp_email_notification,
                library_digest_email_frequency: user.library_digest_email_frequency,
                mention_email_notification: user.mention_email_notification,
                automated_email_notification: workflowEmail
            })
        }
    }

    const assignQuestionResponse = () => {
        const existingMemberAnswer = user && user.screening_response

        setQuestionResponse(membershipQuestions.map((membershipQuestion: any) => {

            let matchingScreeningQuestion = existingMemberAnswer && existingMemberAnswer.find(
                (screenQuestion: any) =>
                    screenQuestion.id === membershipQuestion.id
            );

            if (!matchingScreeningQuestion) {
                matchingScreeningQuestion = existingMemberAnswer && existingMemberAnswer.find(
                    (screenQuestion: any) => (screenQuestion.type === membershipQuestion.type) &&
                        (screenQuestion.question === membershipQuestion.name)
                );
            }

            return {
                id: membershipQuestion.id,
                question: membershipQuestion.name,
                type: membershipQuestion.type,
                answer: matchingScreeningQuestion ? matchingScreeningQuestion.answer :
                    (membershipQuestion.type === QuestionTypes.Checkbox ? [] : ""),
            };
        }));
    }

    React.useEffect(() => {
        if (userDetails) {
            if (editProfileDetailsPopup.editType === 'profile') {
                getCountries();
                getTimezones();
            }
            else {
                const itemFound: any = automatedEmailSettings && Object.keys(automatedEmailSettings).find(key => key.startsWith('_') && Number(key.replace('_', '')) === (group && group.id));
                setAutomatedEmailSettings(userDetails.automated_email_notification)
                if (automatedEmailSettings !== null) {
                    setWorkflowEmail(automatedEmailSettings[itemFound])
                } else {
                    setWorkflowEmail(true)
                }
            }
        }
    }, [userDetails]);

    React.useEffect(() => {
        if (user) {
            setNotificationsFormData({
                broadcast_email_notification: user.broadcast_email_notification,
                post_email_notification: user.post_email_notification,
                unread_messages_email_notification: user.unread_messages_email_notification,
                course_email_notification: user.course_email_notification,
                digest_email_frequency: user.digest_email_frequency,
                event_digest_email_frequency: user.event_digest_email_frequency,
                event_rsvp_email_notification: user.event_rsvp_email_notification,
                library_digest_email_frequency: user.library_digest_email_frequency,
                mention_email_notification: user.mention_email_notification,
                automated_email_notification: workflowEmail
            })
        }
    }, [user]);

    React.useEffect(() => {
        setNotificationsFormData(
            {
                ...notificationsFormData,
                automated_email_notification: workflowEmail
            }
        )
    }, [workflowEmail]);

    React.useEffect(() => {
        function getCommunityFieldsData() {
            if (group && (editProfileDetailsPopup.editType === 'profile')) {
                GroupService.getInstance()
                    .getCommunityFields(group && group.id, 'custom')
                    .then((response: any) => {
                        if (response && response.data) {
                            const customData = response.data
                                // .filter((newData: any) => newData.required === true || newData.ask_during_sign_up === true)
                                .sort((a: any, b: any) => a.position - b.position);
                            setMembershipQuestions([...customData]);
                        }
                    }).catch((error: any) => console.error(error))
            }
        }

        getCommunityFieldsData();

    }, [group]);

    React.useEffect(() => {
        if (
            membershipQuestions &&
            membershipQuestions.length > 0 &&
            (editProfileDetailsPopup.editType === 'profile')
        ) {
            assignQuestionResponse()
        }
    }, [membershipQuestions, user]);

    React.useEffect(() => {
        if (questionResponse && Object.keys(questionResponse).length > 0) {
            // On first load, store initial values for comparison
            if (initialQuestionsRef.current.size === 0) {
                questionResponse.forEach((q: any) => initialQuestionsRef.current.set(q.id, q));
            }

            setUpdatedAnswers((prev: any) => {
                const prevArray = Array.isArray(prev) ? prev : [];
                const updatedMap = new Map(prevArray.map(item => [item.id, item]));

                questionResponse.forEach((q: any) => {
                    const original = initialQuestionsRef.current.get(q.id);
                    // Only track changes compared to the initial values
                    if (original && original.answer !== q.answer) {
                        updatedMap.set(q.id, q);
                    }
                });

                return Array.from(updatedMap.values());
            });
        } else {
            setUpdatedAnswers([])
        }
    }, [questionResponse]);


    return (
        <ReactModal
            isOpen={editProfileDetailsPopup.isOpen}
            className={styles.EditProfileDetailsByAdmin}
            style={{
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 214748364,
                }
            }}
        >
            <div className={styles.EditProfileDetailsByAdmin__header}>
                {
                    editProfileDetailsPopup.editType === 'profile'
                        ?
                        <h1>Edit Profile Details</h1>
                        :
                        <h1>Edit Profile Notification Preferences</h1>
                }
                <div
                    className={styles.EditProfileDetailsByAdmin__close_icon}
                    onClick={() => {
                        seteditProfileDetailsPopup(
                            {
                                isOpen: false,
                                editType: ''
                            }
                        )
                    }}
                >
                    <XIcon />
                </div>
            </div>
            <PerfectScrollbar
                className={styles.EditProfileDetailsByAdmin__body}
                options={{
                    wheelPropagation: false,
                }}
            >
                {
                    editProfileDetailsPopup.editType === 'profile' ?
                        <>
                            <div className={styles.EditProfileDetailsByAdmin__body__group}>
                                <label>Full name</label>
                                <input
                                    onChange={onChange}
                                    value={(userData && userData.full_name) || ""}
                                    name="full_name"
                                    type="text"
                                    aria-label="Full name"
                                />
                            </div>

                            <div className={styles.EditProfileDetailsByAdmin__body__group}>
                                <label>Headline</label>
                                <input
                                    onChange={onChange}
                                    value={(userData && userData.headline) || ""}
                                    name="headline"
                                    type="text"
                                    aria-label="Headline"
                                    maxLength={120}
                                />
                            </div>

                            <div className={styles.EditProfileDetailsByAdmin__body__group}>
                                <label>Phone Number</label>
                                <PhoneInput
                                    international
                                    countryCallingCodeEditable={true}
                                    placeholder='Enter your phone number'
                                    defaultCountry="US"
                                    value={(userData && userData.phone) || ''}
                                    onChange={(value: any) => {
                                        setUserData({ ...userData, 'phone': value });
                                        setEditData({ ...editData, 'phone': value })
                                    }}
                                    name='phone'
                                    type='tel'
                                    aria-label='Phone'
                                    id='phone'
                                    className='phone-input-edit'
                                />
                            </div>

                            <div className={styles.EditProfileDetailsByAdmin__body__group}>
                                <label>Email</label>
                                <input
                                    onChange={onChange}
                                    value={(userData && userData.email) || ""}
                                    name="email"
                                    type="text"
                                    aria-label="Email"
                                    disabled
                                    style={{
                                        backgroundColor: '#f0f1f3'
                                    }}
                                />
                            </div>

                            <div className={styles.EditProfileDetailsByAdmin__body__group}>
                                <label>Country</label>
                                <select
                                    onChange={onChange}
                                    name="country_id"
                                >
                                    <option value="null" className="user-settings-form-group-country-options">Select Country</option>
                                    {countries &&
                                        countries.map((country: any) => {
                                            return (
                                                <option
                                                    key={country.id}
                                                    value={country.id}
                                                    selected={
                                                        userData.country
                                                        && userData.country.id === country.id
                                                    }
                                                >
                                                    {country.name}
                                                </option>
                                            )
                                        })}
                                </select>
                            </div>

                            <div className={styles.EditProfileDetailsByAdmin__body__group}>
                                <label>City</label>
                                <input
                                    onChange={onChange}
                                    value={(userData && userData.location) || ""}
                                    name="location"
                                    type="text"
                                    aria-label="Location"
                                />
                            </div>

                            <div className={styles.EditProfileDetailsByAdmin__body__group}>
                                <label>Timezone</label>
                                <select
                                    onChange={onChange}
                                    name="timezone_id"
                                >
                                    <option value="null">Select Timezone</option>
                                    {timezones &&
                                        timezones.map((timezone: any) => {
                                            return (
                                                <option
                                                    key={timezone.id}
                                                    value={timezone.id}
                                                    selected={
                                                        userData.timezone &&
                                                        userData.timezone.id === timezone.id
                                                    }
                                                >
                                                    {timezone.text}
                                                </option>
                                            )
                                        })}
                                </select>
                            </div>

                            <div className={styles.EditProfileDetailsByAdmin__body__group}>
                                <label>Job title</label>
                                <input
                                    onChange={onChange}
                                    value={(userData && userData.job_title) || ""}
                                    name="job_title"
                                    type="text"
                                    aria-label="Job title"
                                />
                            </div>

                            <div className={styles.EditProfileDetailsByAdmin__body__group}>
                                <label>Bio</label>
                                <textarea
                                    onChange={onChange}
                                    value={(userData && userData.about_me) || ""}
                                    name="about_me"
                                />
                            </div>

                            <p className={styles.EditProfileDetailsByAdmin__body__links__header}>Website & Social media</p>
                            <div className={styles.EditProfileDetailsByAdmin__body__links}>
                                <label>Website URL</label>
                                <div className={styles.EditProfileDetailsByAdmin__body__links__link}>
                                    <div className={styles.EditProfileDetailsByAdmin__body__links__icon}>
                                        <Website />
                                    </div>
                                    <input
                                        type="text"
                                        onChange={onChange}
                                        value={(userData && userData.website) || ""}
                                        placeholder="Enter URL"
                                        name="website"
                                        aria-label="Website"
                                    />
                                </div>

                                <label>Linkedin URL</label>
                                <div className={styles.EditProfileDetailsByAdmin__body__links__link}>
                                    <div className={styles.EditProfileDetailsByAdmin__body__links__icon}>
                                        <LinkedIn />
                                    </div>
                                    <input
                                        type="text"
                                        onChange={onChange}
                                        value={(userData && userData.linkedin) || ""}
                                        placeholder="Enter profile link"
                                        name="linkedin"
                                        aria-label="Linkedin"
                                    />
                                </div>

                                <label>Facebook URL</label>
                                <div className={styles.EditProfileDetailsByAdmin__body__links__link}>
                                    <div className={styles.EditProfileDetailsByAdmin__body__links__icon}>
                                        <Facebook />
                                    </div>
                                    <input
                                        type="text"
                                        onChange={onChange}
                                        value={(userData && userData.facebook) || ""}
                                        placeholder="Enter profile link"
                                        name="facebook"
                                        aria-label="Facebook"
                                    />
                                </div>

                                <label>Instagram URL</label>
                                <div className={styles.EditProfileDetailsByAdmin__body__links__link}>
                                    <div className={styles.EditProfileDetailsByAdmin__body__links__icon}>
                                        <IG />
                                    </div>
                                    <input
                                        type="text"
                                        onChange={onChange}
                                        value={(userData && userData.instagram) || ""}
                                        placeholder="Enter profile link"
                                        name="instagram"
                                        aria-label="Instagram"
                                    />
                                </div>

                                <label>X account URL (Formerly Twitter)</label>
                                <div className={styles.EditProfileDetailsByAdmin__body__links__link}>
                                    <div className={styles.EditProfileDetailsByAdmin__body__links__icon}>
                                        <Twitter />
                                    </div>
                                    <input
                                        type="text"
                                        onChange={onChange}
                                        value={(userData && userData.twitter) || ""}
                                        placeholder="Enter profile link"
                                        name="twitter"
                                        aria-label="Twitter"
                                    />
                                </div>
                            </div>

                            {
                                membershipQuestions &&
                                membershipQuestions.length > 0 &&
                                <>
                                    <p className={styles.EditProfileDetailsByAdmin__body__custom__header}>Custom fields</p>
                                    <ol className={styles.EditProfileDetailsByAdmin__body__custom}>
                                        {
                                            membershipQuestions &&
                                            membershipQuestions.map((question: any, index: number) => (
                                                <li key={index}>
                                                    <SingleQuestion
                                                        membershipQuestion={question}
                                                        questionIndex={index}
                                                        key={question.id}
                                                        responseState={questionResponse}
                                                        setResponseState={setQuestionResponse}
                                                        group={group}
                                                    />
                                                </li>
                                            ))}
                                    </ol>
                                </>
                            }

                        </>
                        :
                        <>
                            <div className={styles.EditProfileDetailsByAdmin__body__notifications}>
                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>Digest emails</h1>
                                    <span>Get a summary of community posts and activities.</span>
                                    <SelectionDropDown
                                        options={digestEmailOptions}
                                        defaultOption={
                                            notificationsFormData.digest_email_frequency === 0 ? 'Never'
                                                :
                                                notificationsFormData.digest_email_frequency === 1 ? 'Daily'
                                                    :
                                                    notificationsFormData.digest_email_frequency === 7 ? ' Weekly'
                                                        : notificationsFormData.digest_email_frequency === 14 ? 'Every 14-days'
                                                            : notificationsFormData.digest_email_frequency === 30 ? 'Monthly'
                                                                : ''
                                        }
                                        toggleOption={(option: any) => {
                                            setEditData({ ...editData, digest_email_frequency: option === 'Never' ? 0 : option === 'Daily' ? 1 : option === 'Weekly' ? 7 : option === 'Every 14-days' ? 14 : 30 });
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}
                                    />
                                </div>

                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>Admin announcements</h1>
                                    <span>Notify me when group admins share a post.</span>
                                    <SelectionDropDown
                                        options={['Yes', 'No']}
                                        defaultOption={notificationsFormData.broadcast_email_notification ? 'Yes' : 'No'}
                                        toggleOption={(opt: any) => {
                                            if (opt === 'Yes') {
                                                setEditData({ ...editData, broadcast_email_notification: true });
                                            } else {
                                                setEditData({ ...editData, broadcast_email_notification: false });
                                            }
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}
                                    />
                                </div>

                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>Upcoming events notification</h1>
                                    <span>Notify me about upcoming events.</span>
                                    <SelectionDropDown
                                        options={upComimgEventEmailOptions}
                                        defaultOption={notificationsFormData.event_digest_email_frequency === 0 ? 'Never' : notificationsFormData.event_digest_email_frequency === 1 ? 'Daily' : notificationsFormData.event_digest_email_frequency === 7 ? 'Weekly' : notificationsFormData.event_digest_email_frequency === 14 ? 'Every 14-days' : notificationsFormData.event_digest_email_frequency === 30 ? 'Monthly' : ''}
                                        toggleOption={(option: any) => {
                                            setEditData({ ...editData, event_digest_email_frequency: option === 'Never' ? 0 : option === 'Daily' ? 1 : option === 'Weekly' ? 7 : option === 'Every 14-days' ? 14 : 30 });
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}
                                    />
                                </div>

                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>Event reminder notifications</h1>
                                    <span>Notify me about events I have RSVPed for.</span>
                                    <SelectionDropDown
                                        options={['Yes', 'No']}
                                        defaultOption={notificationsFormData.event_rsvp_email_notification ? 'Yes' : 'No'}
                                        toggleOption={(opt: any) => {
                                            if (opt === 'Yes') {
                                                setEditData({ ...editData, event_rsvp_email_notification: true });
                                            } else {
                                                setEditData({ ...editData, event_rsvp_email_notification: false });
                                            }
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}
                                    />
                                </div>

                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>Post comments</h1>
                                    <span>Notify me when someone comments on my post.</span>
                                    <SelectionDropDown
                                        options={['Yes', 'No']}
                                        defaultOption={notificationsFormData.post_email_notification ? 'Yes' : 'No'}
                                        toggleOption={(opt: any) => {
                                            if (opt === 'Yes') {
                                                setEditData({ ...editData, post_email_notification: true });
                                            } else {
                                                setEditData({ ...editData, post_email_notification: false });
                                            }
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}
                                    />
                                </div>

                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>Mention notifications</h1>
                                    <span>Notify me when someone tags me on post or comment.</span>
                                    <SelectionDropDown
                                        options={['Yes', 'No']}
                                        defaultOption={notificationsFormData.mention_email_notification ? 'Yes' : 'No'}
                                        toggleOption={(opt: any) => {
                                            if (opt === 'Yes') {
                                                setEditData({ ...editData, mention_email_notification: true });
                                            } else {
                                                setEditData({ ...editData, mention_email_notification: false });
                                            }
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}

                                    />
                                </div>

                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>Unread message notifications</h1>
                                    <span>Notify me when I have unread messages.</span>
                                    <SelectionDropDown
                                        options={['Yes', 'No']}
                                        defaultOption={notificationsFormData.unread_messages_email_notification ? 'Yes' : 'No'}
                                        toggleOption={(opt: any) => {
                                            if (opt === 'Yes') {
                                                setEditData({ ...editData, unread_messages_email_notification: true });
                                            } else {
                                                setEditData({ ...editData, unread_messages_email_notification: false });
                                            }
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}

                                    />
                                </div>

                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>Course announcements</h1>
                                    <span>Notify me when my courses has updates.</span>
                                    <SelectionDropDown
                                        options={['Yes', 'No']}
                                        defaultOption={notificationsFormData.course_email_notification ? 'Yes' : 'No'}
                                        toggleOption={(opt: any) => {
                                            if (opt === 'Yes') {
                                                setEditData({ ...editData, course_email_notification: true });
                                            } else {
                                                setEditData({ ...editData, course_email_notification: false });
                                            }
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}

                                    />
                                </div>

                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>New community content notification</h1>
                                    <span>Notify me when new courses and library content are published.</span>
                                    <SelectionDropDown
                                        options={newContentEmailOptions}
                                        defaultOption={notificationsFormData.library_digest_email_frequency === 0 ? 'Never' : notificationsFormData.library_digest_email_frequency === 1 ? 'Daily' : notificationsFormData.library_digest_email_frequency === 7 ? ' Weekly' : notificationsFormData.library_digest_email_frequency === 14 ? 'Every 14-days' : notificationsFormData.library_digest_email_frequency === 30 ? 'Monthly' : ''}
                                        toggleOption={(option: any) => {
                                            setEditData({ ...editData, library_digest_email_frequency: option === 'Never' ? 0 : option === 'Daily' ? 1 : option === 'Weekly' ? 7 : option === 'Every 14-days' ? 14 : 30 });
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}
                                    />
                                </div>

                                <div className={styles.EditProfileDetailsByAdmin__body__notification}>
                                    <h1>Automated emails</h1>
                                    <span> Emails sent based on specific actions.</span>
                                    <SelectionDropDown
                                        options={['Yes', 'No']}
                                        defaultOption={notificationsFormData.automated_email_notification ? 'Yes' : 'No'}
                                        toggleOption={(opt: any) => {
                                            if (opt === 'Yes') {
                                                setEditData({
                                                    ...editData, automated_email_notification: {
                                                        ...automatedEmailSettings,
                                                        [`_${group && group.id}`]: true
                                                    }
                                                });
                                            } else {
                                                setEditData({
                                                    ...editData, automated_email_notification:
                                                    {
                                                        ...automatedEmailSettings,
                                                        [`_${group && group.id}`]: false
                                                    }
                                                });
                                            }
                                        }}
                                        arrowDownstyles={styles.arrowDownstyles}
                                    />
                                </div>
                            </div>

                        </>
                }
            </PerfectScrollbar>

            <div className={styles.EditProfileDetailsByAdmin__footer}>
                <button onClick={() => handleDiscard()}>
                    Discard
                </button>

                <button
                    // disabled={isSaving || Object.keys(editData).length === 0 || updatedAnswers.length === 0}
                    disabled={isSaving || (editData && Object.keys(editData).length === 0 && updatedAnswers.length === 0)}
                    onClick={handleForm}
                    className={`${(Object.keys(editData).length === 0 && (updatedAnswers.length === 0)) ? styles.EditProfileDetailsByAdmin__footer__disabled : ''}`}
                >
                    {
                        isSaving ? 'Saving...' : 'Save Changes'
                    }
                </button>

            </div>
        </ReactModal >
    )
}

export default EditProfileDetailsByAdmin
